import type { ExperimentalQueries } from '../__types__/ExperimentalQueries'; //eslint-disable-line no-restricted-imports
import { MediaType } from '../MediaType';

export const experimentalAnalyticsSpaceContentViewExport: ExperimentalQueries['experimentalAnalyticsSpaceContentViewExport'] =
	(_, { cloudId, fromDate, toDate, spaceKey, spaceId, timezone, content, period }, { network }) => {
		const params = new URLSearchParams({
			fromDate,
			toDate,
			spaceKey,
			spaceId,
			timezone,
			content,
			period,
		});
		return network
			.cfetch(
				`/gateway/api/ex/confluence/${cloudId}/analytics/space/contentViews/report?${params.toString()}`,
				{
					method: 'GET',
					credentials: 'include',
					headers: {
						'Content-Type': MediaType.JSON,
					},
				},
			)
			.then((response) => response.json())
			.then((responseJson) => {
				return responseJson;
			});
	};
